import { registerLicense } from '@syncfusion/ej2-base';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

registerLicense('Ngo9BigBOggjHTQxAR8/V1JHaF5cWWdCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdlWXpeeHRSR2RYWE1/V0ZWYEo=');

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
